import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import {
  withAccountsSiteMap,
  siteMapPropType,
  processor,
} from '@bingads-webui-campaign-react/with-site-map';
import { AccountsSummaryBar } from '@bingads-webui-campaign-react/summary-bar';

export const Loader = (props) => {
  const { siteMap, updateAvailability, ...others } = props;

  const selectedParent = _.findWhere(siteMap, { selected: true });

  useEffect(() => {
    updateAvailability(!_.isEmpty(selectedParent));
  });

  return selectedParent
    ? (<AccountsSummaryBar selectedParent={selectedParent} breadCrumbText={props.i18n.getString(_TL_('Accounts'))} {...others} />)
    : null;
};

Loader.propTypes = {
  siteMap: siteMapPropType.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  updateAvailability: PropTypes.func,
};

Loader.defaultProps = {
  updateAvailability: _.noop,
};

const processors = [processor.processPermissions, processor.processPath];

export const AccountsSummaryBarLoader = withAccountsSiteMap(
  React.memo(Loader),
  processors
);
